export const OPTIONS_DATE_PICKER = {
	FORMAT_RE: /,|\.|-| |:|\/|\\/,
	DAY_RE: /D+/,
	MONTH_RE: /M+/,
	YEAR_RE: /Y+/,
	HOURS_RE: /h+/i,
	MINUTES_RE: /m+/,
	SECONDS_RE: /s+/,
	AMPMClockRE: /A/
};
